/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AssetResponseDto,
  DeleteFolderRequestDto,
  FolderResponseDto,
  FolderUpdateRequestDto,
  ProblemDetails,
  TeamFolderCreateRequestDto,
  TeamFolderShareRequestDto,
  TransferRequestDto,
  UserFolderShareRequestDto,
  UsersTeamsFolderResponseDto,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Folders<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Creates a new folder under the specified team. The authenticated user must have Editor or Owner permission in the target team. Returns 400 BadRequest if the user has Viewer permission or does not belong to the team.
   *
   * @tags Folders
   * @name FoldersCreate
   * @summary Create a new team folder
   * @request POST:/folders
   * @secure
   */
  foldersCreate = (
    data: TeamFolderCreateRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<FolderResponseDto, ProblemDetails | void>({
      path: `/folders`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Updates the title or other metadata of a specified folder. Requires Editor or Owner permission in the team-folder relationship. Viewers cannot perform this action.
   *
   * @tags Folders
   * @name FoldersPartialUpdate
   * @summary Update folder by ID
   * @request PATCH:/folders/{folderId}
   * @secure
   */
  foldersPartialUpdate = (
    folderId: string,
    data: FolderUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/folders/${folderId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Marks a folder as permanently deleted and removes its associated team catalog links. Requires Editor or Owner permission in the team-folder relationship. Viewers cannot perform this action.
   *
   * @tags Folders
   * @name FoldersDelete
   * @summary Delete a folder
   * @request DELETE:/folders/{folderId}
   * @secure
   */
  foldersDelete = (
    folderId: string,
    data: DeleteFolderRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/folders/${folderId}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Fetches details of a specific folder that has not been deleted. The caller must belong to one of the teams the folder is granted to; Viewer permission is enough. Returns 403 Forbidden otherwise.
   *
   * @tags Folders
   * @name FoldersDetail
   * @summary Get folder by ID
   * @request GET:/folders/{folderId}
   * @secure
   */
  foldersDetail = (folderId: string, params: RequestParams = {}) =>
    this.request<FolderResponseDto, ProblemDetails | void>({
      path: `/folders/${folderId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Reassigns ownership of the folder (and all of its assets) to the target team. All existing folder shares are dropped and pending invitations are cleared. **Permissions:** SuperAdmin can transfer any folder. Regular users must be the creator owner (IsCreator) of both the source folder's team and the destination team. **Returns:** `204 No Content` on success. **Error Codes:** `400 BadRequest` - Folder or destination team not found. `403 Forbidden` - Caller is not authorized to transfer between these teams. `409 Conflict` - The destination team's asset limit would be exceeded by the transfer. `500 InternalServerError` - Unexpected server-side error.
   *
   * @tags Folders
   * @name TransferCreate
   * @summary Transfer a folder to another team
   * @request POST:/folders/{folderId}/transfer
   * @secure
   */
  transferCreate = (
    folderId: string,
    data: TransferRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/folders/${folderId}/transfer`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Fetches all assets belonging to a specific folder. The caller must belong to one of the teams the folder is granted to; Viewer permission is enough. Returns 403 Forbidden otherwise.
   *
   * @tags Folders
   * @name AssetsList
   * @summary Get assets for a specific folder by ID
   * @request GET:/folders/{folderId}/assets
   * @secure
   */
  assetsList = (folderId: string, params: RequestParams = {}) =>
    this.request<AssetResponseDto[], ProblemDetails | void>({
      path: `/folders/${folderId}/assets`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Fetches the list of users and teams with permissions for the folder. The caller must belong to one of the teams the folder is granted to; Viewer permission is enough. Returns 403 Forbidden otherwise.
   *
   * @tags Folders
   * @name MembersList
   * @summary Get folder permissions and members
   * @request GET:/folders/{folderId}/members
   * @secure
   */
  membersList = (folderId: string, params: RequestParams = {}) =>
    this.request<UsersTeamsFolderResponseDto, ProblemDetails | void>({
      path: `/folders/${folderId}/members`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Shares a folder with teams, revokes access, or updates permissions for existing teams. Requires Editor or Owner permission in the team-folder relationship. Viewers cannot perform this action. A team's default folder cannot be shared - its members are the owning team's members. Adding teams to one returns 400 BadRequest; revoking and re-permissioning still apply.
   *
   * @tags Folders
   * @name MembersTeamsCreate
   * @summary Share a folder with teams
   * @request POST:/folders/{folderId}/members/teams
   * @secure
   */
  membersTeamsCreate = (
    folderId: string,
    data: TeamFolderShareRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/folders/${folderId}/members/teams`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Shares a folder with specific users, revokes access, or updates permissions. Requires Editor or Owner permission in the team-folder relationship. Viewers cannot perform this action. A team's default folder cannot be shared - its members are the owning team's members. Adding members to one returns 400 BadRequest; revoking and re-permissioning still apply.
   *
   * @tags Folders
   * @name MembersUsersCreate
   * @summary Share a folder with users
   * @request POST:/folders/{folderId}/members/users
   * @secure
   */
  membersUsersCreate = (
    folderId: string,
    data: UserFolderShareRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/folders/${folderId}/members/users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
